export function isLastPinned(shouldPinFirstRow: boolean | number, rowIndex: number): boolean {
  return rowIndex + 1 === Number(shouldPinFirstRow);
}
